export function openChatSupport() {
  window.tidioChatApi.display(true);
  window.tidioChatApi.open();
}
